import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex align-items-center justify-content-center",
  style: {"height":"100%"}
}
const _hoisted_2 = { class: "p-component surface-card p-4 shadow-2 border-round w-full lg:w-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-900 text-3xl font-medium mb-3" }, "TMM Pipeline")
], -1)
const _hoisted_4 = {
  action: "/login",
  method: "post"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-900 font-medium mb-2",
  for: "login"
}, "Login", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-900 font-medium mb-2",
  for: "password"
}, "Password", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createElementVNode("form", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_InputText, {
            id: "login",
            name: "username",
            type: "text",
            class: "w-full mb-3"
          }),
          _hoisted_6,
          _createVNode(_component_InputText, {
            id: "password",
            name: "password",
            class: "w-full mb-3",
            type: "password"
          }),
          _createVNode(_component_Button, {
            label: "Sign In",
            icon: "pi pi-user",
            class: "w-full mt-3",
            type: "submit"
          })
        ])
      ])
    ])
  ]))
}